(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (() => {
    const bookingItems = Array.from(document.querySelectorAll('[data-cart-booking-item]'));
    if (bookingItems.length === 0) return;

    const checkoutButton = document.querySelector('.cart-summary__checkout');
    const availabilityBaseUrl = '/apps/bookings/availability';
    const holdBaseUrl = '/apps/bookings/holds';

    let pendingCount = 0;
    let blockedCount = 0;

    const setCheckoutState = () => {
      if (!checkoutButton) return;
      checkoutButton.disabled = pendingCount > 0 || blockedCount > 0;
    };

    const beginPending = () => {
      pendingCount += 1;
      setCheckoutState();
    };

    const endPending = () => {
      pendingCount = Math.max(0, pendingCount - 1);
      setCheckoutState();
    };

    const setBlocked = (item, isBlocked) => {
      const alreadyBlocked = item.dataset.bookingBlocked === 'true';
      if (isBlocked && !alreadyBlocked) {
        item.dataset.bookingBlocked = 'true';
        blockedCount += 1;
      } else if (!isBlocked && alreadyBlocked) {
        item.dataset.bookingBlocked = 'false';
        blockedCount = Math.max(0, blockedCount - 1);
      }
      setCheckoutState();
    };

    const setStatus = (item, message, tone = 'default', visible = true) => {
      const status = item.querySelector('[data-cart-booking-status]');
      if (!status) return;
      status.textContent = message || '';
      status.dataset.tone = tone;
      status.hidden = !visible || !message;
    };

    const getProperties = (item) => {
      const script = document.querySelector(`[data-cart-booking-properties="${CSS.escape(item.dataset.lineKey)}"]`);
      if (!script) return {};

      try {
        return JSON.parse(script.textContent || '{}') || {};
      } catch (_error) {
        return {};
      }
    };

    const updatePropertiesScript = (item, properties) => {
      const script = document.querySelector(`[data-cart-booking-properties="${CSS.escape(item.dataset.lineKey)}"]`);
      if (script) {
        script.textContent = JSON.stringify(properties);
      }
    };

    const getBookingIntakeAnswers = (item) => {
      const rawValue = getProperties(item)._booking_intake_answers;
      if (!rawValue) return {};

      try {
        return JSON.parse(rawValue) || {};
      } catch (_error) {
        return {};
      }
    };

    const updateScheduleDisplay = (item, schedule, holdId, expiresAt, slotIds) => {
      const summary = item.querySelector('[data-cart-booking-value]');
      if (summary) summary.textContent = schedule;
      item.dataset.selectedSchedule = schedule;
      item.dataset.holdId = holdId || '';
      item.dataset.holdExpiresAt = expiresAt || '';
      item.dataset.slotIds = slotIds || '';

      const properties = {
        ...getProperties(item),
        'Selected schedule': schedule,
        _booking_hold_id: holdId || '',
        _booking_hold_expires_at: expiresAt || '',
        _booking_slot_ids: slotIds || ''
      };

      updatePropertiesScript(item, properties);
    };

    const hideRebookUI = (item) => {
      const rebook = item.querySelector('[data-cart-booking-rebook]');
      const dateSelect = item.querySelector('[data-cart-booking-date]');
      const timeSelect = item.querySelector('[data-cart-booking-time]');
      const button = item.querySelector('[data-cart-booking-reserve]');
      if (!rebook) return;

      rebook.hidden = true;

      if (dateSelect) {
        dateSelect.innerHTML = '<option value="">Select a date</option>';
      }

      if (timeSelect) {
        timeSelect.innerHTML = '<option value="">Select a time</option>';
        timeSelect.disabled = true;
      }

      if (button) {
        button.disabled = true;
      }
    };

    const updateCartLineProperties = async (item, nextProperties) => {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: item.dataset.lineKey,
          quantity: Number(item.querySelector('input[name="updates[]"]')?.value || 1),
          properties: nextProperties
        })
      });

      if (!response.ok) {
        throw new Error(`Cart update failed with ${response.status}`);
      }

      return response.json();
    };

    const loadAvailability = async (item) => {
      const url = new URL(availabilityBaseUrl, window.location.origin);
      url.searchParams.set('productId', item.dataset.productId || '');
      url.searchParams.set('variantId', item.dataset.variantId || '');
      url.searchParams.set('mode', item.dataset.bookingMode || 'single');

      const response = await fetch(url.toString(), { headers: { Accept: 'application/json' } });
      if (!response.ok) {
        throw new Error(`Availability request failed with ${response.status}`);
      }

      const payload = await response.json();
      return payload.dates || [];
    };

    const findSlotById = (dates, slotId) => {
      for (const date of dates) {
        for (const time of date.times || []) {
          if (time.id === slotId) {
            return {
              id: time.id,
              date: date.date,
              dateLabel: date.label,
              timeLabel: time.label
            };
          }
        }
      }
      return null;
    };

      const createHold = async (item, selectedSlot) => {
        const response = await fetch(holdBaseUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          productId: item.dataset.productId,
          variantId: item.dataset.variantId,
          bookingType: (getProperties(item)['Booking type'] || '').toLowerCase(),
          bookingMode: item.dataset.bookingMode || 'single',
          selectedSlots: [selectedSlot],
          bookingIntakeAnswers: getBookingIntakeAnswers(item)
        })
      });

      if (!response.ok) {
        throw new Error(`Hold request failed with ${response.status}`);
      }

        return response.json();
      };

      const releaseHold = async (holdId) => {
        if (!holdId) return;

        await fetch(`${holdBaseUrl}/release`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({holdId})
        });
      };

    const showRebookUI = (item, dates) => {
      const rebook = item.querySelector('[data-cart-booking-rebook]');
      const dateSelect = item.querySelector('[data-cart-booking-date]');
      const timeSelect = item.querySelector('[data-cart-booking-time]');
      const button = item.querySelector('[data-cart-booking-reserve]');
      if (!rebook || !dateSelect || !timeSelect || !button) return;

      rebook.hidden = false;
      dateSelect.innerHTML = '<option value="">Select a date</option>';
      timeSelect.innerHTML = '<option value="">Select a time</option>';
      timeSelect.disabled = true;
      button.disabled = true;

      dates.forEach((entry) => {
        const option = document.createElement('option');
        option.value = entry.date;
        option.textContent = entry.label;
        dateSelect.appendChild(option);
      });

      const populateTimes = () => {
        const selectedDate = dates.find((entry) => entry.date === dateSelect.value);
        timeSelect.innerHTML = '<option value="">Select a time</option>';

        if (!selectedDate) {
          timeSelect.disabled = true;
          button.disabled = true;
          return;
        }

        selectedDate.times.forEach((time) => {
          const option = document.createElement('option');
          option.value = time.id;
          option.textContent = time.label;
          option.dataset.dateLabel = selectedDate.label;
          option.dataset.timeLabel = time.label;
          timeSelect.appendChild(option);
        });

        timeSelect.disabled = false;
      };

      dateSelect.onchange = () => {
        populateTimes();
      };

      timeSelect.onchange = () => {
        button.disabled = !timeSelect.value;
      };

      button.onclick = async () => {
        const selectedOption = timeSelect.selectedOptions[0];
        if (!selectedOption || !selectedOption.value) return;

        beginPending();
        try {
          setStatus(item, 'Reserving a new session...', 'loading');
          const selectedSlot = {
            id: selectedOption.value,
            date: dateSelect.value,
            dateLabel: selectedOption.dataset.dateLabel || dateSelect.selectedOptions[0]?.textContent || '',
            timeLabel: selectedOption.dataset.timeLabel || selectedOption.textContent || ''
          };
          const hold = await createHold(item, selectedSlot);
          const nextProperties = {
            ...getProperties(item),
            'Selected schedule': `${selectedSlot.dateLabel} at ${selectedSlot.timeLabel}`,
            _booking_hold_id: hold.id || '',
            _booking_hold_expires_at: hold.expiresAt || '',
            _booking_slot_ids: selectedSlot.id
          };
          await updateCartLineProperties(item, nextProperties);
          updatePropertiesScript(item, nextProperties);
          updateScheduleDisplay(
            item,
            nextProperties['Selected schedule'],
            nextProperties._booking_hold_id,
            nextProperties._booking_hold_expires_at,
            nextProperties._booking_slot_ids
          );
          hideRebookUI(item);
          setBlocked(item, false);
          setStatus(item, 'Reservation refreshed. You can continue to checkout.', 'success');
        } catch (error) {
          console.error(error);
          setStatus(item, 'We could not reserve that new session. Please choose another time.', 'error');
        } finally {
          endPending();
        }
      };
    };

    const handleExpiredHold = async (item) => {
      beginPending();
      try {
        setStatus(item, 'Checking whether your reserved session can be refreshed...', 'loading');
        const dates = await loadAvailability(item);
        const originalSlotId = String(item.dataset.slotIds || '').split(',').map((entry) => entry.trim()).filter(Boolean)[0];
        const originalSlot = findSlotById(dates, originalSlotId);

        if (originalSlot) {
          const hold = await createHold(item, originalSlot);
          const nextProperties = {
            ...getProperties(item),
            'Selected schedule': `${originalSlot.dateLabel} at ${originalSlot.timeLabel}`,
            _booking_hold_id: hold.id || '',
            _booking_hold_expires_at: hold.expiresAt || '',
            _booking_slot_ids: originalSlot.id
          };
          await updateCartLineProperties(item, nextProperties);
          updatePropertiesScript(item, nextProperties);
          updateScheduleDisplay(
            item,
            nextProperties['Selected schedule'],
            nextProperties._booking_hold_id,
            nextProperties._booking_hold_expires_at,
            nextProperties._booking_slot_ids
          );
          hideRebookUI(item);
          setBlocked(item, false);
          setStatus(item, 'Your reserved session was still available, so we refreshed the hold for you.', 'success');
          return;
        }

        if ((item.dataset.bookingMode || 'single') !== 'single') {
          setBlocked(item, true);
          setStatus(item, 'This series reservation expired. Please return to the product page to choose sessions again.', 'error');
          return;
        }

        setBlocked(item, true);
        setStatus(item, 'Your reservation expired and that original session is no longer available. Choose a new one below.', 'error');
        showRebookUI(item, dates);
      } catch (error) {
        console.error(error);
        setBlocked(item, true);
        setStatus(item, 'We could not refresh this reservation automatically. Choose a new session below.', 'error');
        try {
          const dates = await loadAvailability(item);
          showRebookUI(item, dates);
        } catch (_availabilityError) {
          setStatus(item, 'We could not load replacement sessions right now. Please refresh the page.', 'error');
        }
      } finally {
        endPending();
      }
    };

    const verifyHold = async (item) => {
      const holdId = item.dataset.holdId;
      if (!holdId) return;

      const holdExpiresAt = item.dataset.holdExpiresAt;
      if (holdExpiresAt) {
        const expiresAtMs = Date.parse(holdExpiresAt);
        if (Number.isFinite(expiresAtMs) && expiresAtMs <= Date.now()) {
          await handleExpiredHold(item);
          return;
        }
      }

      beginPending();
      try {
        const response = await fetch(`${holdBaseUrl}/${encodeURIComponent(holdId)}`, {
          headers: { Accept: 'application/json' }
        });

        if (response.ok) {
          hideRebookUI(item);
          setBlocked(item, false);
          setStatus(item, '', 'default', false);
          return;
        }

        if (response.status === 404 || response.status === 410) {
          await handleExpiredHold(item);
          return;
        }

        throw new Error(`Hold lookup failed with ${response.status}`);
      } catch (error) {
        console.error(error);
        setBlocked(item, true);
        setStatus(item, 'We could not verify this reservation. Please refresh the page before checking out.', 'error');
      } finally {
        endPending();
      }
    };

      setCheckoutState();
      bookingItems.forEach((item) => {
        const removeLink = item.querySelector('[data-cart-booking-remove]');
        if (removeLink) {
          removeLink.addEventListener('click', async (event) => {
            event.preventDefault();
            removeLink.setAttribute('aria-disabled', 'true');

            try {
              await releaseHold(item.dataset.holdId || '');
            } catch (error) {
              console.warn('Unable to release booking hold before cart removal', error);
            }

            window.location.href = removeLink.href;
          });
        }

        void verifyHold(item);
      });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root = document) => {
      const openButton = root.querySelector('[data-collection-expect-open]');
      if (!openButton || openButton.dataset.bound === 'true') return;

      const modalId = openButton.getAttribute('aria-controls');
      const modal = modalId ? document.getElementById(modalId) : null;
      if (!modal) return;

      const closeButton = modal.querySelector('[data-collection-expect-close]');

      const closeModal = () => {
        if (modal.open) modal.close();
      };

      openButton.addEventListener('click', () => {
        if (typeof modal.showModal === 'function') {
          modal.showModal();
        }
      });

      if (closeButton) closeButton.addEventListener('click', closeModal);

      modal.addEventListener('click', (event) => {
        const rect = modal.getBoundingClientRect();
        const clickedOutside =
          event.clientX < rect.left ||
          event.clientX > rect.right ||
          event.clientY < rect.top ||
          event.clientY > rect.bottom;
        if (clickedOutside) closeModal();
      });

      openButton.dataset.bound = 'true';
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(document));
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', (event) => {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"]) return;
  try {
    
  const contactPage = document.querySelector('.contact-page');

  if (contactPage) {
    const phoneInput = contactPage.querySelector('[data-phone-input]');
    const phonePreferenceInputs = Array.from(contactPage.querySelectorAll('[data-phone-requires-contact]'));
    const phoneRequiredIndicator = contactPage.querySelector('[data-phone-required-indicator]');
    const preferredContactMethodsInput = contactPage.querySelector('[data-preferred-contact-methods]');
    const contactMethodInputs = Array.from(contactPage.querySelectorAll('[data-contact-method-option]'));
    const formElements = {
      name: contactPage.querySelector('#ContactFormName'),
      email: contactPage.querySelector('#ContactFormEmail'),
      phone: contactPage.querySelector('#ContactFormPhone'),
      subject: contactPage.querySelector('#ContactFormSubject'),
      body: contactPage.querySelector('#ContactFormBody')
    };

    const syncPhoneRequirement = () => {
      if (!phoneInput || phonePreferenceInputs.length === 0) {
        return;
      }

      const requiresPhone = phonePreferenceInputs.some((input) => input.checked);
      phoneInput.required = requiresPhone;

      if (phoneRequiredIndicator) {
        phoneRequiredIndicator.hidden = !requiresPhone;
      }
    };

    const syncPreferredContactMethods = () => {
      if (!preferredContactMethodsInput) {
        return;
      }

      preferredContactMethodsInput.value = contactMethodInputs
        .filter((input) => input.checked)
        .map((input) => input.value)
        .join(', ');
    };

    const prefillFromQuery = () => {
      const params = new URLSearchParams(window.location.search);
      const fieldMap = [
        ['contact[name]', formElements.name],
        ['contact[email]', formElements.email],
        ['contact[phone]', formElements.phone],
        ['contact[Subject]', formElements.subject],
        ['contact[body]', formElements.body]
      ];

      fieldMap.forEach(([paramName, field]) => {
        if (!field || field.value) {
          return;
        }

        const paramValue = params.get(paramName);
        if (paramValue) {
          field.value = paramValue;
        }
      });

      const preferredMethods = params.getAll('contact[Preferred contact methods][]');
      if (preferredMethods.length > 0 && contactMethodInputs.length > 0) {
        contactMethodInputs.forEach((input) => {
          if (preferredMethods.includes(input.value)) {
            input.checked = true;
          }
        });
      }
    };

    prefillFromQuery();

    if (phonePreferenceInputs.length > 0) {
      phonePreferenceInputs.forEach((input) => {
        input.addEventListener('change', syncPhoneRequirement);
      });
    }

    if (contactMethodInputs.length > 0) {
      contactMethodInputs.forEach((input) => {
        input.addEventListener('change', syncPreferredContactMethods);
      });
    }

    syncPreferredContactMethods();
    syncPhoneRequirement();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const button = document.querySelector('[data-back-to-top]');
    if (!button || button.dataset.bound === 'true') return;

    const toggleVisibility = () => {
      if (window.scrollY > 320) {
        button.hidden = false;
      } else {
        button.hidden = true;
      }
    };

    button.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    button.dataset.bound = 'true';
    window.addEventListener('scroll', toggleVisibility, { passive: true });
    toggleVisibility();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const init = (root = document) => {
      const shell = root.querySelector('[data-header-shell]');
      const spacer = root.querySelector('[data-header-spacer]');
      if (!shell || !spacer) return;

      const header = shell.querySelector('.site-header');
      const mobileToggle = shell.querySelector('[data-header-mobile-toggle]');
      const mobileMenu = shell.querySelector('[data-header-mobile-menu]');

      let lastScrollY = window.scrollY;
      let lastScrollTs = performance.now();

      const syncSpacerHeight = () => {
        if (window.innerWidth <= 900) {
          spacer.style.height = '0px';
          return;
        }

        spacer.style.height = `${shell.offsetHeight}px`;
      };

      const syncScrolledState = () => {
        if (window.innerWidth <= 900) {
          shell.classList.remove('is-scrolled');
          return;
        }

        shell.classList.toggle('is-scrolled', window.scrollY > 24);
      };

      const syncMobileMenuState = () => {
        if (!header || !mobileToggle || !mobileMenu) return;

        if (window.innerWidth <= 900) {
          const isOpen = header.classList.contains('is-mobile-menu-open');
          mobileToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
          mobileMenu.hidden = !isOpen;
          return;
        }

        header.classList.remove('is-mobile-menu-open');
        mobileToggle.setAttribute('aria-expanded', 'false');
        mobileMenu.hidden = false;
      };

      const syncTransitionSpeed = () => {
        if (window.innerWidth <= 900) {
          shell.style.setProperty('--header-transition-ms', '180ms');
          lastScrollY = window.scrollY;
          lastScrollTs = performance.now();
          return;
        }

        const now = performance.now();
        const deltaY = Math.abs(window.scrollY - lastScrollY);
        const deltaT = Math.max(now - lastScrollTs, 16);
        const velocity = deltaY / deltaT;
        const duration = Math.round(Math.max(90, Math.min(360, 360 - velocity * 220)));

        shell.style.setProperty('--header-transition-ms', `${duration}ms`);
        lastScrollY = window.scrollY;
        lastScrollTs = now;
      };

      if (shell.dataset.bound === 'true') {
        syncSpacerHeight();
        syncTransitionSpeed();
        syncScrolledState();
        syncMobileMenuState();
        return;
      }

      shell.dataset.bound = 'true';
      window.addEventListener('resize', () => {
        syncSpacerHeight();
        syncTransitionSpeed();
        syncScrolledState();
        syncMobileMenuState();
      });
      window.addEventListener('load', () => {
        syncSpacerHeight();
        syncTransitionSpeed();
        syncScrolledState();
        syncMobileMenuState();
      });
      window.addEventListener(
        'scroll',
        () => {
          syncTransitionSpeed();
          syncScrolledState();
        },
        { passive: true }
      );

      const logoImage = shell.querySelector('.header__logo-image');
      if (logoImage) {
        logoImage.addEventListener('load', syncSpacerHeight);
      }

      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(syncSpacerHeight);
        observer.observe(shell);
      }

      if ('MutationObserver' in window) {
        const mutationObserver = new MutationObserver(syncSpacerHeight);
        mutationObserver.observe(shell, {
          attributes: true,
          childList: true,
          subtree: true
        });
      }

      if (mobileToggle && header) {
        mobileToggle.addEventListener('click', () => {
          if (window.innerWidth > 900) return;
          header.classList.toggle('is-mobile-menu-open');
          syncMobileMenuState();
          syncSpacerHeight();
        });
      }

      syncSpacerHeight();
      syncTransitionSpeed();
      syncScrolledState();
      syncMobileMenuState();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(document));
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', (event) => {
      init(event.target);
    });
    document.addEventListener('shopify:section:select', (event) => {
      init(event.target);
    });
    document.addEventListener('shopify:section:deselect', (event) => {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bindHeroModal = (root) => {
      const toggles = root.querySelectorAll('[data-modal-open]');
      toggles.forEach((toggle) => {
        if (toggle.dataset.bound === 'true') return;

        const modalId = toggle.getAttribute('aria-controls');
        const modal = modalId ? document.getElementById(modalId) : null;
        if (!modal) return;

        const closeButtons = modal.querySelectorAll('[data-modal-close]');

        const openModal = () => {
          if (typeof modal.showModal === 'function') {
            modal.showModal();
          } else {
            modal.setAttribute('open', 'open');
          }
          document.body.classList.add('overflow-hidden');
        };

        const closeModal = () => {
          if (typeof modal.close === 'function') {
            modal.close();
          } else {
            modal.removeAttribute('open');
          }
          document.body.classList.remove('overflow-hidden');
          toggle.focus();
        };

        toggle.addEventListener('click', openModal);

        closeButtons.forEach((button) => {
          button.addEventListener('click', closeModal);
        });

        modal.addEventListener('click', (event) => {
          if (event.target === modal) {
            closeModal();
          }
        });

        modal.addEventListener('close', () => {
          document.body.classList.remove('overflow-hidden');
          toggle.focus();
        });

        toggle.dataset.bound = 'true';
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => bindHeroModal(document));
    } else {
      bindHeroModal(document);
    }

    document.addEventListener('shopify:section:load', (event) => {
      bindHeroModal(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
    const initGallery = (root) => {
      const gallery = root.querySelector('[data-product-gallery]');
      if (!gallery || gallery.dataset.bound === 'true') return;

      const thumbs = Array.from(gallery.querySelectorAll('[data-product-gallery-thumb]'));
      const slides = Array.from(gallery.querySelectorAll('[data-product-gallery-slide]'));

      if (!thumbs.length || !slides.length) {
        gallery.dataset.bound = 'true';
        return;
      }

      const setActiveImage = (imageId) => {
        slides.forEach((slide) => {
          const isActive = slide.dataset.imageId === imageId;
          slide.hidden = !isActive;
          slide.classList.toggle('is-active', isActive);
        });

        thumbs.forEach((thumb) => {
          const isActive = thumb.dataset.imageId === imageId;
          thumb.classList.toggle('is-active', isActive);
          thumb.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      };

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          if (!thumb.dataset.imageId) return;
          setActiveImage(thumb.dataset.imageId);
        });
      });

      gallery.dataset.bound = 'true';
    };

    const sampleAvailability = [
      {
        date: '2026-03-18',
        label: 'Wednesday, March 18',
        times: [
          { id: 'slot-2026-03-18-1000', label: '10:00 AM' },
          { id: 'slot-2026-03-18-1400', label: '2:00 PM' }
        ]
      },
      {
        date: '2026-03-25',
        label: 'Wednesday, March 25',
        times: [
          { id: 'slot-2026-03-25-1000', label: '10:00 AM' },
          { id: 'slot-2026-03-25-1400', label: '2:00 PM' }
        ]
      },
      {
        date: '2026-04-01',
        label: 'Wednesday, April 1',
        times: [
          { id: 'slot-2026-04-01-1000', label: '10:00 AM' },
          { id: 'slot-2026-04-01-1400', label: '2:00 PM' }
        ]
      }
    ];

    const formatCountdown = (remainingMs) => {
      const totalSeconds = Math.max(0, Math.floor(remainingMs / 1000));
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;
      return `${minutes}:${String(seconds).padStart(2, '0')}`;
    };

    const initProductPage = (root) => {
      const page = root.querySelector('[data-product-page]');
      if (!page || page.dataset.bound === 'true') return;

      page.dataset.bound = 'true';

      if (page.dataset.bookingEnabled !== 'true') return;

      const form = page.querySelector('[data-product-form]');
      const unavailableState = page.querySelector('[data-booking-unavailable]');
      const variantSelect = page.querySelector('[data-variant-select]');
      const dateSelect = page.querySelector('[data-booking-date]');
      const timeSelect = page.querySelector('[data-booking-time]');
      const timeButtons = page.querySelector('[data-booking-time-buttons]');
      const calendarWrap = page.querySelector('[data-booking-calendar]');
      const calendarMonth = page.querySelector('[data-booking-calendar-month]');
      const calendarGrid = page.querySelector('[data-booking-calendar-grid]');
      const calendarPrev = page.querySelector('[data-booking-calendar-prev]');
      const calendarNext = page.querySelector('[data-booking-calendar-next]');
      const sessionCountInput = page.querySelector('[data-booking-session-count]');
      const addSessionButton = page.querySelector('[data-booking-add-session]');
      const holdButton = page.querySelector('[data-booking-hold]');
      const submitButton = page.querySelector('[data-product-submit]');
      const status = page.querySelector('[data-booking-status]');
      const bookingBody = page.querySelector('[data-booking-body]');
      const bookingLoading = page.querySelector('[data-booking-loading]');
      const selectionWrap = page.querySelector('[data-booking-selection]');
      const selectionList = page.querySelector('[data-booking-selection-list]');
      const holdSummary = page.querySelector('[data-booking-hold-summary]');
      const heldSlot = page.querySelector('[data-booking-held-slot]');
      const countdown = page.querySelector('[data-booking-countdown]');
      const scheduleInput = page.querySelector('[data-booking-schedule-input]');
      const slotIdsInput = page.querySelector('[data-booking-slot-ids]');
      const holdIdInput = page.querySelector('[data-booking-hold-id]');
      const holdExpiresInput = page.querySelector('[data-booking-hold-expires-at]');
      const bookingReferenceInput = page.querySelector('[data-booking-reference]');
      const intakeWrap = page.querySelector('[data-booking-intake]');
      const intakeFieldsRoot = page.querySelector('[data-booking-intake-fields]');
      const intakeAnswersInput = page.querySelector('[data-booking-intake-answers]');

      const bookingMode = page.dataset.bookingMode || 'single';
      const configUrl = page.dataset.configUrl || '/apps/bookings/config';
      const availabilityUrl = page.dataset.availabilityUrl;
      const holdUrl = page.dataset.holdUrl;
      const releaseUrl = page.dataset.releaseUrl;
      const fallbackHoldMinutes = Number(page.dataset.holdMinutes || 10);
      const requiredSessionsDefault = Number(page.dataset.requiredSessions || 1);
      const isSingleMode = bookingMode !== 'series';

      let availability = [];
      let selectedSlots = [];
      let hold = null;
      let holdTimer = null;
      let currentVariantId = variantSelect.value;
      let visibleMonth = null;
      let selectedTimeId = '';
      let interactionToken = 0;
      let activeHoldToken = 0;
      let hasLoadedAvailabilityOnce = false;
      let bookingConfig = {
        intakeFields: []
      };

      const clearHoldTimer = () => {
        if (holdTimer) {
          window.clearInterval(holdTimer);
          holdTimer = null;
        }
      };

      const resetBookingUiState = () => {
        clearHoldTimer();
        hold = null;
        activeHoldToken = 0;
        selectedSlots = [];
        selectedTimeId = '';
        holdIdInput.value = '';
        holdExpiresInput.value = '';
        scheduleInput.value = '';
        slotIdsInput.value = '';
        if (bookingReferenceInput) bookingReferenceInput.value = '';
        if (holdSummary) holdSummary.hidden = true;
        if (heldSlot) heldSlot.textContent = '';
        if (countdown) countdown.textContent = '';
        timeSelect.innerHTML = '<option value="">Select a time</option>';
        timeSelect.disabled = true;
        timeSelect.hidden = true;
        if (timeButtons) {
          timeButtons.hidden = true;
          timeButtons.innerHTML = '';
        }
      };

      const safeStorage = {
        get(key) {
          try {
            return window.sessionStorage.getItem(key);
          } catch (_error) {
            return null;
          }
        },
        set(key, value) {
          try {
            window.sessionStorage.setItem(key, value);
          } catch (_error) {
            // Ignore storage failures and keep the booking flow usable.
          }
        },
        remove(key) {
          try {
            window.sessionStorage.removeItem(key);
          } catch (_error) {
            // Ignore storage failures and keep the booking flow usable.
          }
        }
      };

      const buildStorageKey = (variantId) =>
        `kith-kin-booking-hold:${page.dataset.productId || 'unknown'}:${variantId || 'unknown'}`;

      const getDateRecord = (dateValue) => availability.find((entry) => entry.date === dateValue);

      const parseDateValue = (dateValue) => {
        if (!dateValue) return null;
        return new Date(`${dateValue}T12:00:00`);
      };

      const monthKeyForDate = (dateValue) => {
        const parsed = parseDateValue(dateValue);
        return parsed ? `${parsed.getFullYear()}-${parsed.getMonth()}` : '';
      };

      const formatMonthLabel = (year, monthIndex) =>
        new Intl.DateTimeFormat(undefined, { month: 'long', year: 'numeric' }).format(
          new Date(year, monthIndex, 1)
        );

      const saveHoldState = () => {
        if (!hold) return;
        safeStorage.set(
          buildStorageKey(currentVariantId),
          JSON.stringify({
            productPath: window.location.pathname,
            productId: String(page.dataset.productId || ''),
            variantId: String(currentVariantId || ''),
            hold,
            selectedSlots,
            bookingIntakeAnswers: collectIntakeAnswers()
          })
        );
      };

      const clearStoredHoldState = (variantId = currentVariantId) => {
        safeStorage.remove(buildStorageKey(variantId));
      };

      const nextInteractionToken = () => {
        interactionToken += 1;
        return interactionToken;
      };

      const setStatus = (message, tone = 'default') => {
        if (!hasLoadedAvailabilityOnce && tone === 'loading') {
          status.innerHTML = '';
          status.dataset.tone = 'default';
          status.hidden = true;
          return;
        }

        status.hidden = false;
        status.innerHTML = '';
        status.dataset.tone = tone;

        if (tone === 'loading') {
          const loader = document.createElement('span');
          loader.className = 'booking-panel__status-loader';

          const palette = document.createElement('span');
          palette.className = 'booking-panel__status-palette';
          palette.setAttribute('aria-hidden', 'true');

          for (let index = 1; index <= 8; index += 1) {
            const dot = document.createElement('span');
            dot.className = `booking-panel__status-dot booking-panel__status-dot--${index}`;
            palette.appendChild(dot);
          }

          const text = document.createElement('span');
          text.className = 'booking-panel__status-loader-text';
          text.textContent = message;

          const srText = document.createElement('span');
          srText.className = 'visually-hidden';
          srText.textContent = message;

          loader.appendChild(palette);
          loader.appendChild(text);
          loader.appendChild(srText);
          status.appendChild(loader);
          return;
        }

        status.textContent = message;

        if (!hasLoadedAvailabilityOnce && bookingLoading && !bookingLoading.hidden) {
          status.hidden = true;
        }
      };

      const setInitialAvailabilityLoadingState = (isLoading) => {
        if (!bookingBody || !bookingLoading || hasLoadedAvailabilityOnce) {
          return;
        }

        bookingBody.hidden = isLoading;
        bookingLoading.hidden = !isLoading;
        status.hidden = isLoading;
      };

      const finishInitialAvailabilityLoadingState = () => {
        if (!bookingBody || !bookingLoading || hasLoadedAvailabilityOnce) {
          return;
        }

        hasLoadedAvailabilityOnce = true;
        bookingBody.hidden = false;
        bookingLoading.hidden = true;

        if (!status.textContent.trim()) {
          status.hidden = false;
        }
      };

      const getBookingErrorMessage = (error, fallbackMessage) => {
        const message = error instanceof Error ? String(error.message || '').trim() : '';
        return message || fallbackMessage;
      };

      const getIntakeFields = () =>
        Array.isArray(bookingConfig.intakeFields)
          ? bookingConfig.intakeFields.filter(
              (field) => field?.microsoftFieldId && field?.status !== 'broken'
            )
          : [];

      const getIntakeFieldInputId = (fieldId) =>
        `BookingIntake-${String(page.dataset.productId || 'product')}-${String(fieldId || 'field').replace(/[^a-zA-Z0-9_-]+/g, '-')}`;

      const normalizeIntakeAnswerValue = (field, value) => {
        if (field.microsoftFieldType === 'boolean') {
          return Boolean(value);
        }

        if (field.microsoftFieldType === 'number') {
          const normalized = String(value ?? '').trim();
          if (normalized === '') return '';
          const numericValue = Number(normalized);
          return Number.isFinite(numericValue) ? numericValue : '';
        }

        if (Array.isArray(value)) {
          return value.map((entry) => String(entry || '').trim()).filter(Boolean);
        }

        return String(value ?? '').trim();
      };

      const hasIntakeAnswer = (field, answer) => {
        if (Array.isArray(answer)) {
          return answer.length > 0;
        }

        if (typeof answer === 'boolean') {
          return true;
        }

        return String(answer ?? '').trim().length > 0;
      };

      const clearIntakeErrors = () => {
        if (!intakeFieldsRoot) return;
        intakeFieldsRoot.querySelectorAll('[data-booking-intake-error]').forEach((node) => {
          node.textContent = '';
          node.hidden = true;
        });
      };

      const collectIntakeAnswers = () => {
        const answers = {};

        getIntakeFields().forEach((field) => {
          if (!intakeFieldsRoot) return;

          const input = intakeFieldsRoot.querySelector(`[data-booking-intake-input="${CSS.escape(field.microsoftFieldId)}"]`);
          if (!input) return;

          let value = '';
          if (field.microsoftFieldType === 'boolean') {
            value = Boolean(input.checked);
          } else if (field.microsoftFieldType === 'number') {
            value = input.value;
          } else {
            value = input.value;
          }

          answers[field.microsoftFieldId] = normalizeIntakeAnswerValue(field, value);
        });

        return answers;
      };

      const syncIntakeAnswersInput = () => {
        if (!intakeAnswersInput) return;
        intakeAnswersInput.value = JSON.stringify(collectIntakeAnswers());
      };

      const applyIntakeAnswers = (answers = {}) => {
        getIntakeFields().forEach((field) => {
          if (!intakeFieldsRoot) return;
          const input = intakeFieldsRoot.querySelector(`[data-booking-intake-input="${CSS.escape(field.microsoftFieldId)}"]`);
          if (!input) return;

          const value = answers[field.microsoftFieldId];
          if (field.microsoftFieldType === 'boolean') {
            input.checked = Boolean(value);
          } else if (typeof value === 'number') {
            input.value = String(value);
          } else if (Array.isArray(value)) {
            input.value = value[0] || '';
          } else {
            input.value = String(value || '');
          }
        });

        syncIntakeAnswersInput();
      };

      const validateIntakeAnswers = ({ showErrors = false } = {}) => {
        let isValid = true;

        if (showErrors) {
          clearIntakeErrors();
        }

        getIntakeFields().forEach((field) => {
          const answer = collectIntakeAnswers()[field.microsoftFieldId];
          const hasAnswer = hasIntakeAnswer(field, answer);

          if (field.microsoftRequired && !hasAnswer) {
            isValid = false;
            if (showErrors && intakeFieldsRoot) {
              const errorNode = intakeFieldsRoot.querySelector(
                `[data-booking-intake-error="${CSS.escape(field.microsoftFieldId)}"]`
              );
              if (errorNode) {
                errorNode.textContent = `${field.shopifyLabel || field.microsoftFieldLabel || 'This field'} is required.`;
                errorNode.hidden = false;
              }
            }
          }
        });

        return isValid;
      };

      const renderIntakeFields = () => {
        if (!intakeWrap || !intakeFieldsRoot) return;

        const fields = getIntakeFields();
        const previousAnswers = collectIntakeAnswers();
        intakeFieldsRoot.innerHTML = '';

        if (fields.length === 0) {
          intakeWrap.hidden = true;
          syncIntakeAnswersInput();
          return;
        }

        intakeWrap.hidden = false;

        fields.forEach((field) => {
          const fieldWrap = document.createElement('div');
          fieldWrap.className = 'booking-panel__intake-field';

          const label = document.createElement('label');
          label.className = 'booking-panel__intake-label';
          label.setAttribute('for', getIntakeFieldInputId(field.microsoftFieldId));
          label.textContent = field.shopifyLabel || field.microsoftFieldLabel || 'Booking question';

          if (field.microsoftRequired) {
            const badge = document.createElement('span');
            badge.className = 'booking-panel__intake-required';
            badge.textContent = 'Required';
            label.appendChild(badge);
          }

          fieldWrap.appendChild(label);

          if (field.helpText) {
            const help = document.createElement('p');
            help.className = 'booking-panel__intake-help';
            help.textContent = field.helpText;
            fieldWrap.appendChild(help);
          }

          let input = null;
          if (field.microsoftFieldType === 'multiline_text') {
            input = document.createElement('textarea');
            input.rows = 3;
          } else if (field.microsoftFieldType === 'choice' && Array.isArray(field.answerOptions) && field.answerOptions.length > 0) {
            input = document.createElement('select');
            const placeholderOption = document.createElement('option');
            placeholderOption.value = '';
            placeholderOption.textContent = 'Select an option';
            input.appendChild(placeholderOption);
            field.answerOptions.forEach((optionValue) => {
              const option = document.createElement('option');
              option.value = optionValue;
              option.textContent = optionValue;
              input.appendChild(option);
            });
          } else if (field.microsoftFieldType === 'boolean') {
            const checkboxWrap = document.createElement('label');
            checkboxWrap.className = 'booking-panel__intake-checkbox';
            input = document.createElement('input');
            input.type = 'checkbox';
            const checkboxText = document.createElement('span');
            checkboxText.textContent = 'Yes';
            checkboxWrap.appendChild(input);
            checkboxWrap.appendChild(checkboxText);
            fieldWrap.appendChild(checkboxWrap);
          } else {
            input = document.createElement('input');
            input.type = field.microsoftFieldType === 'number' ? 'number' : 'text';
          }

          if (input) {
            input.id = getIntakeFieldInputId(field.microsoftFieldId);
            input.dataset.bookingIntakeInput = field.microsoftFieldId;
            if (field.microsoftFieldType !== 'boolean') {
              fieldWrap.appendChild(input);
            }
          }

          const error = document.createElement('p');
          error.className = 'booking-panel__intake-error';
          error.dataset.bookingIntakeError = field.microsoftFieldId;
          error.hidden = true;
          fieldWrap.appendChild(error);

          intakeFieldsRoot.appendChild(fieldWrap);
        });

        applyIntakeAnswers(previousAnswers);
        clearIntakeErrors();
      };

      const loadBookingConfig = async () => {
        if (!configUrl) {
          bookingConfig = { intakeFields: [] };
          renderIntakeFields();
          return;
        }

        const url = new URL(configUrl, window.location.origin);
        url.searchParams.set('productId', page.dataset.productId || '');
        url.searchParams.set('variantId', variantSelect.value || '');

        try {
          const response = await fetch(url.toString(), {
            headers: { Accept: 'application/json' }
          });

          if (!response.ok) {
            throw new Error(`Config request failed with ${response.status}`);
          }

          bookingConfig = await response.json();
        } catch (error) {
          console.warn('Unable to load booking intake fields.', error);
          bookingConfig = { intakeFields: [] };
        }

        renderIntakeFields();
      };

      const applyNoAvailabilityState = () => {
        if (form) form.hidden = true;
        if (unavailableState) unavailableState.hidden = false;
        dateSelect.value = '';
        dateSelect.disabled = true;
        timeSelect.innerHTML = '<option value="">Select a time</option>';
        timeSelect.disabled = true;
        timeSelect.hidden = true;
        if (timeButtons) {
          timeButtons.hidden = true;
          timeButtons.innerHTML = '';
        }
        if (selectionWrap) selectionWrap.hidden = true;
        if (selectionList) {
          selectionList.hidden = true;
          selectionList.innerHTML = '';
        }
        holdButton.disabled = true;
        submitButton.disabled = true;
      };

      const clearNoAvailabilityState = () => {
        if (form) form.hidden = false;
        if (unavailableState) unavailableState.hidden = true;
      };

      const invalidateHold = async ({ release = true, storageKey = currentVariantId } = {}) => {
        clearHoldTimer();
        const holdToRelease = hold;

        if (release && holdToRelease && releaseUrl) {
          try {
            await fetch(releaseUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ holdId: holdToRelease.id })
            });
          } catch (error) {
            console.warn('Unable to release booking hold', error);
          }
        }

        hold = null;
        activeHoldToken = 0;
        holdIdInput.value = '';
        holdExpiresInput.value = '';
        if (bookingReferenceInput) bookingReferenceInput.value = '';
        submitButton.disabled = true;
        holdSummary.hidden = true;
        if (heldSlot) heldSlot.textContent = '';
        clearStoredHoldState(storageKey);
      };

      const renderHoldSummary = (slots = selectedSlots) =>
        slots.map((slot) => `${slot.dateLabel} at ${slot.timeLabel}`).join(' | ');

      const showExpiredHoldSummary = () => {
        clearHoldTimer();
        hold = null;
        activeHoldToken = 0;
        holdIdInput.value = '';
        holdExpiresInput.value = '';
        if (bookingReferenceInput) bookingReferenceInput.value = '';
        submitButton.disabled = true;
        holdSummary.hidden = false;
        if (heldSlot) {
          heldSlot.textContent = renderHoldSummary() || 'Your reserved session is no longer available.';
        }
        if (countdown) countdown.textContent = 'This reservation has expired.';
        clearStoredHoldState();
      };

      const updateSelectionUI = () => {
        syncIntakeAnswersInput();
        const entries = selectedSlots.map((slot) => {
          const item = document.createElement('li');
          item.className = 'booking-panel__selection-item';
          item.innerHTML = `
            <span>${slot.dateLabel} at ${slot.timeLabel}</span>
            <button type="button" class="booking-panel__remove" data-slot-id="${slot.id}">Remove</button>
          `;
          return item;
        });

        selectionList.innerHTML = '';
        entries.forEach((entry) => selectionList.appendChild(entry));

        const empty = selectionWrap.querySelector('.booking-panel__selection-empty');
        if (selectedSlots.length === 0) {
          empty.hidden = false;
          selectionList.hidden = true;
        } else {
          empty.hidden = true;
          selectionList.hidden = false;
        }

        scheduleInput.value = selectedSlots.map((slot) => `${slot.dateLabel} at ${slot.timeLabel}`).join(' | ');
        slotIdsInput.value = selectedSlots.map((slot) => slot.id).join(',');

        const requiredCount =
          bookingMode === 'series'
            ? Math.max(1, Number(sessionCountInput?.value || requiredSessionsDefault))
            : 1;
        const readyForHold = selectedSlots.length === requiredCount;
        const intakeReady = validateIntakeAnswers();

        holdButton.disabled = !readyForHold;
        submitButton.disabled = !(hold && holdIdInput.value && intakeReady);
      };

      const renderTimeButtons = (times, selectedDate) => {
        if (!timeButtons) return;

        timeButtons.innerHTML = '';

        times.forEach((time) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'booking-time-button';
          button.textContent = time.label;
          button.dataset.slotId = time.id;
          button.dataset.timeLabel = time.label;
          button.dataset.dateValue = selectedDate.date;
          button.dataset.dateLabel = selectedDate.label;

          if (time.id === selectedTimeId) {
            button.classList.add('booking-time-button--selected');
          }

          timeButtons.appendChild(button);
        });
      };

      const renderCalendar = () => {
        if (!calendarGrid || !calendarMonth) return;

        if (availability.length === 0) {
          calendarMonth.textContent = 'Class currently full';
          calendarGrid.innerHTML = '';
          if (calendarPrev) calendarPrev.disabled = true;
          if (calendarNext) calendarNext.disabled = true;
          applyNoAvailabilityState();
          return;
        }

        clearNoAvailabilityState();
        dateSelect.disabled = false;

        const availableDateSet = new Set(availability.map((entry) => entry.date));
        const monthKeys = Array.from(new Set(availability.map((entry) => monthKeyForDate(entry.date)))).filter(Boolean);
        const selectedDate = dateSelect.value;
        const selectedMonthKey = monthKeyForDate(selectedDate);
        const initialMonthKey = selectedMonthKey || monthKeys[0];

        if (!visibleMonth || !monthKeys.includes(`${visibleMonth.year}-${visibleMonth.month}`)) {
          const [year, month] = initialMonthKey.split('-').map(Number);
          visibleMonth = { year, month };
        }

        const activeMonthKey = `${visibleMonth.year}-${visibleMonth.month}`;
        const monthIndex = monthKeys.indexOf(activeMonthKey);

        if (calendarPrev) calendarPrev.disabled = monthIndex <= 0;
        if (calendarNext) calendarNext.disabled = monthIndex === -1 || monthIndex >= monthKeys.length - 1;

        calendarMonth.textContent = formatMonthLabel(visibleMonth.year, visibleMonth.month);
        calendarGrid.innerHTML = '';

        const firstOfMonth = new Date(visibleMonth.year, visibleMonth.month, 1);
        const firstWeekday = firstOfMonth.getDay();
        const daysInMonth = new Date(visibleMonth.year, visibleMonth.month + 1, 0).getDate();
        const todayKey = new Date().toISOString().slice(0, 10);

        for (let index = 0; index < firstWeekday; index += 1) {
          const spacer = document.createElement('div');
          spacer.className = 'booking-calendar__day booking-calendar__day--empty';
          calendarGrid.appendChild(spacer);
        }

        for (let day = 1; day <= daysInMonth; day += 1) {
          const dateValue = `${visibleMonth.year}-${String(visibleMonth.month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'booking-calendar__day';
          button.textContent = String(day);
          button.dataset.date = dateValue;

          if (availableDateSet.has(dateValue)) {
            button.classList.add('booking-calendar__day--available');
          } else {
            button.disabled = true;
          }

          if (dateValue === selectedDate) {
            button.classList.add('booking-calendar__day--selected');
          }

          if (dateValue === todayKey) {
            button.classList.add('booking-calendar__day--today');
          }

          calendarGrid.appendChild(button);
        }
      };

      const populateTimes = () => {
        const selectedDate = getDateRecord(dateSelect.value);
        timeSelect.innerHTML = '<option value="">Select a time</option>';
        selectedTimeId = '';

        if (!selectedDate) {
          timeSelect.disabled = true;
          timeSelect.hidden = true;
          if (timeButtons) {
            timeButtons.hidden = true;
            timeButtons.innerHTML = '';
          }
          return;
        }

        selectedDate.times.forEach((time) => {
          const option = document.createElement('option');
          option.value = time.id;
          option.textContent = time.label;
          option.dataset.timeLabel = time.label;
          option.dataset.dateLabel = selectedDate.label;
          timeSelect.appendChild(option);
        });

        const shouldUseDropdown = selectedDate.times.length > 5;
        timeSelect.disabled = false;
        timeSelect.hidden = !shouldUseDropdown;

        if (timeButtons) {
          timeButtons.hidden = shouldUseDropdown;
          if (!shouldUseDropdown) {
            renderTimeButtons(selectedDate.times, selectedDate);
          } else {
            timeButtons.innerHTML = '';
          }
        }
      };

      const populateDates = () => {
        const previousDateValue = dateSelect.value;
        dateSelect.innerHTML = '<option value="">Select a date</option>';

        availability.forEach((entry) => {
          const option = document.createElement('option');
          option.value = entry.date;
          option.textContent = entry.label;
          dateSelect.appendChild(option);
        });

        if (availability.length > 0) {
          const preferredDate =
            previousDateValue && availability.some((entry) => entry.date === previousDateValue)
              ? previousDateValue
              : availability[0].date;
          dateSelect.value = preferredDate;
        }

        setStatus(
          availability.length > 0
            ? 'Availability loaded.'
            : 'This class is currently full or temporarily unavailable. Check back soon or try another session.',
          availability.length > 0 ? 'default' : 'error'
        );
        renderCalendar();
      };

      const loadAvailability = async () => {
        setInitialAvailabilityLoadingState(true);
        setStatus('Loading availability...', 'loading');

        if (!availabilityUrl) {
          availability = sampleAvailability;
          populateDates();
          return;
        }

        const url = new URL(availabilityUrl, window.location.origin);
        url.searchParams.set('productId', page.dataset.productId || '');
        url.searchParams.set('variantId', variantSelect.value);
        url.searchParams.set('mode', bookingMode);

        try {
          const response = await fetch(url.toString(), {
            headers: { Accept: 'application/json' }
          });

          if (!response.ok) throw new Error(`Availability request failed with ${response.status}`);

          const payload = await response.json();
          availability = payload.dates || [];
          populateDates();
          populateTimes();
        } catch (error) {
          console.warn('Unable to load live availability, falling back to sample data.', error);
          availability = sampleAvailability;
          populateDates();
          populateTimes();
          setStatus('Sample availability loaded. Connect the app proxy for live data.', 'loading');
        }
      };

      const applySelectedSlotToInputs = () => {
        const firstSlot = selectedSlots[0];
        if (!firstSlot) {
          dateSelect.value = '';
          timeSelect.innerHTML = '<option value="">Select a time</option>';
          timeSelect.disabled = true;
          renderCalendar();
          return;
        }

        dateSelect.value = firstSlot.date;
        const selectedMonthDate = parseDateValue(firstSlot.date);
        if (selectedMonthDate) {
          visibleMonth = {
            year: selectedMonthDate.getFullYear(),
            month: selectedMonthDate.getMonth()
          };
        }
        populateTimes();
        selectedTimeId = firstSlot.id;
        timeSelect.value = firstSlot.id;
        const selectedDate = getDateRecord(firstSlot.date);
        if (selectedDate && selectedDate.times.length <= 5) {
          renderTimeButtons(selectedDate.times, selectedDate);
        }
        renderCalendar();
      };

      const mergeHeldSlotsIntoAvailability = (slots = []) => {
        if (!Array.isArray(slots) || slots.length === 0) {
          return;
        }

        slots.forEach((slot) => {
          if (!slot?.id || !slot?.date) {
            return;
          }

          let dateEntry = availability.find((entry) => entry?.date === slot.date);
          if (!dateEntry) {
            dateEntry = {
              date: slot.date,
              label: slot.dateLabel || slot.date,
              times: []
            };
            availability.push(dateEntry);
          }

          if (!Array.isArray(dateEntry.times)) {
            dateEntry.times = [];
          }

          if (!dateEntry.times.some((time) => time?.id === slot.id)) {
            dateEntry.times.push({
              id: slot.id,
              label: slot.timeLabel || ''
            });
          }
        });

        availability.sort((left, right) => String(left?.date || '').localeCompare(String(right?.date || '')));
      };

      const restorePersistedHold = async () => {
        const stored = safeStorage.get(buildStorageKey(currentVariantId));
        if (!stored) return;

          try {
            const parsed = JSON.parse(stored);
            if (!parsed?.hold?.id || !parsed?.hold?.expiresAt) {
              clearStoredHoldState();
              return;
            }

            const currentProductId = String(page.dataset.productId || '');
            const currentVariantKey = String(currentVariantId || '');
            const currentPath = window.location.pathname;
            if (
              (parsed.productId && String(parsed.productId) !== currentProductId) ||
              (parsed.variantId && String(parsed.variantId) !== currentVariantKey) ||
              (parsed.productPath && String(parsed.productPath) !== currentPath)
            ) {
              clearStoredHoldState();
              resetBookingUiState();
              return;
            }

            if (new Date(parsed.hold.expiresAt).getTime() <= Date.now()) {
              clearStoredHoldState();
              return;
            }

          if (holdUrl) {
            const response = await fetch(`${holdUrl}/${encodeURIComponent(parsed.hold.id)}`, {
              headers: { Accept: 'application/json' }
            });

            if (!response.ok) {
              clearStoredHoldState();
              return;
            }

            hold = await response.json();
          } else {
            hold = parsed.hold;
          }

            if (!hold || hold.status !== 'active') {
              clearStoredHoldState();
              resetBookingUiState();
              hold = null;
              return;
            }

            selectedSlots = Array.isArray(parsed.selectedSlots) ? parsed.selectedSlots : hold.selectedSlots || [];
            mergeHeldSlotsIntoAvailability(selectedSlots);
            populateDates();
            bookingConfig = bookingConfig || { intakeFields: [] };
            applyIntakeAnswers(parsed.bookingIntakeAnswers || hold.bookingIntakeAnswers || {});
            applySelectedSlotToInputs();
            holdIdInput.value = hold.id || '';
            holdExpiresInput.value = hold.expiresAt || '';
            holdSummary.hidden = false;
            if (heldSlot) {
            heldSlot.textContent = renderHoldSummary();
            }
            updateSelectionUI();
            setStatus('Reservation restored. Complete checkout before it expires.', 'success');

          clearHoldTimer();
          syncCountdown();
          holdTimer = window.setInterval(syncCountdown, 1000);
        } catch (error) {
          console.warn('Unable to restore persisted hold', error);
          hold = null;
          clearStoredHoldState();
        }
      };

      const buildSelectedSlot = () => {
        const selectedTime = timeSelect.selectedOptions[0];
        const selectedDate = dateSelect.selectedOptions[0];

        if (!selectedTime || !selectedTime.value || !selectedDate || !selectedDate.value) return null;

        return {
          id: selectedTime.value,
          date: selectedDate.value,
          dateLabel: selectedTime.dataset.dateLabel || selectedDate.textContent,
          timeLabel: selectedTime.dataset.timeLabel || selectedTime.textContent
        };
      };

      const setSelectedTimeFromButton = (button) => {
        if (!button) return null;

        selectedTimeId = button.dataset.slotId || '';
        const selectedDateRecord = getDateRecord(button.dataset.dateValue || dateSelect.value);

        if (selectedDateRecord) {
          renderTimeButtons(selectedDateRecord.times, selectedDateRecord);
        }

        timeSelect.value = selectedTimeId;

        return {
          id: button.dataset.slotId || '',
          date: button.dataset.dateValue || '',
          dateLabel: button.dataset.dateLabel || '',
          timeLabel: button.dataset.timeLabel || button.textContent || ''
        };
      };

      const syncCountdown = () => {
        if (!hold) return;

        const remainingMs = new Date(hold.expiresAt).getTime() - Date.now();
        if (remainingMs <= 0) {
          showExpiredHoldSummary();
          setStatus('Reservation expired. Please choose your sessions again.', 'error');
          return;
        }

        countdown.textContent = `Time remaining: ${formatCountdown(remainingMs)}`;
      };

      const createHold = async (token = interactionToken) => {
        syncIntakeAnswersInput();

        const payload = {
          productId: page.dataset.productId,
          variantId: variantSelect.value,
          bookingType: page.dataset.bookingType,
          bookingMode,
          selectedSlots,
          bookingIntakeAnswers: collectIntakeAnswers()
        };

        setStatus(hold ? 'Updating your reservation...' : 'Reserving selected times...', 'loading');

        if (!holdUrl) {
          const expiresAt = new Date(Date.now() + fallbackHoldMinutes * 60 * 1000).toISOString();
          hold = {
            id: `demo-hold-${Date.now()}`,
            expiresAt
          };
        } else {
          const response = await fetch(holdUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
          });

          if (!response.ok) {
            throw new Error(`Hold request failed with ${response.status}`);
          }

          hold = await response.json();
        }

        if (token !== interactionToken) {
          if (releaseUrl && hold?.id) {
            try {
              await fetch(releaseUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ holdId: hold.id })
              });
            } catch (error) {
              console.warn('Unable to release stale booking hold', error);
            }
          }
          return null;
        }

        activeHoldToken = token;
        holdIdInput.value = hold.id || '';
        holdExpiresInput.value = hold.expiresAt || '';
        holdSummary.hidden = false;
        if (heldSlot) {
          heldSlot.textContent = renderHoldSummary();
        }
        updateSelectionUI();
        setStatus('Reservation held. Complete checkout before it expires.', 'success');
        saveHoldState();

        clearHoldTimer();
        syncCountdown();
        holdTimer = window.setInterval(syncCountdown, 1000);
        return hold;
      };

      dateSelect.addEventListener('change', async () => {
        nextInteractionToken();
        await invalidateHold();
        if (isSingleMode) {
          selectedSlots = [];
          updateSelectionUI();
        }
        selectedTimeId = '';
        const selectedMonthDate = parseDateValue(dateSelect.value);
        if (selectedMonthDate) {
          visibleMonth = {
            year: selectedMonthDate.getFullYear(),
            month: selectedMonthDate.getMonth()
          };
        }
        populateTimes();
        renderCalendar();
      });

      timeSelect.addEventListener('change', async () => {
        const token = nextInteractionToken();
        await invalidateHold();
        selectedTimeId = timeSelect.value || '';

        if (isSingleMode) {
          const slot = buildSelectedSlot();
          selectedSlots = slot ? [slot] : [];
          updateSelectionUI();

          if (!slot) return;

          try {
            await createHold(token);
          } catch (error) {
            if (token !== interactionToken) return;
            console.error(error);
            setStatus(
              getBookingErrorMessage(
                error,
                'Unable to reserve the selected times right now. Please try again.'
              ),
              'error'
            );
            submitButton.disabled = true;
          }
        }
      });

      if (timeButtons) {
        timeButtons.addEventListener('click', async (event) => {
          const button = event.target.closest('[data-slot-id]');
          if (!button) return;

          const token = nextInteractionToken();
          await invalidateHold();

          if (isSingleMode) {
            const slot = setSelectedTimeFromButton(button);
            selectedSlots = slot ? [slot] : [];
            updateSelectionUI();

            if (!slot) return;

            try {
              await createHold(token);
            } catch (error) {
              if (token !== interactionToken) return;
              console.error(error);
              setStatus(
                getBookingErrorMessage(
                  error,
                  'Unable to reserve the selected times right now. Please try again.'
                ),
                'error'
              );
              submitButton.disabled = true;
            }
          }
        });
      }

      if (intakeFieldsRoot) {
        const handleIntakeInputChange = async () => {
          syncIntakeAnswersInput();
          clearIntakeErrors();
          if (hold && holdIdInput.value) {
            saveHoldState();
          }
          updateSelectionUI();

          if (!validateIntakeAnswers({ showErrors: false })) {
            if (hold && holdIdInput.value) {
              setStatus('Complete the required class questions before adding this booking to the cart.', 'error');
            }
            return;
          }

          if (!hold || !holdIdInput.value) {
            return;
          }

          setStatus('Class details updated. Your reservation is still held and ready for checkout.', 'success');
        };

        intakeFieldsRoot.addEventListener('input', () => {
          void handleIntakeInputChange();
        });
        intakeFieldsRoot.addEventListener('change', () => {
          void handleIntakeInputChange();
        });
      }

      if (sessionCountInput) {
        sessionCountInput.addEventListener('input', async () => {
          nextInteractionToken();
          await invalidateHold();
          selectedSlots = selectedSlots.slice(0, Math.max(1, Number(sessionCountInput.value || 1)));
          updateSelectionUI();
        });
      }

      if (addSessionButton) {
        addSessionButton.addEventListener('click', async () => {
          nextInteractionToken();
          await invalidateHold();

          const slot = buildSelectedSlot();
          if (!slot) {
            setStatus('Choose a date and time first.', 'error');
            return;
          }

          if (selectedSlots.some((entry) => entry.id === slot.id)) {
            setStatus('That session is already selected.', 'error');
            return;
          }

          const requiredCount = Math.max(1, Number(sessionCountInput?.value || requiredSessionsDefault));
          if (selectedSlots.length >= requiredCount) {
            setStatus(`You already selected ${requiredCount} sessions.`, 'error');
            return;
          }

          selectedSlots.push(slot);
          setStatus(`${selectedSlots.length} of ${requiredCount} sessions selected.`);
          updateSelectionUI();
        });
      }

      selectionList.addEventListener('click', async (event) => {
        const button = event.target.closest('[data-slot-id]');
        if (!button) return;

        nextInteractionToken();
        await invalidateHold();
        selectedSlots = selectedSlots.filter((slot) => slot.id !== button.dataset.slotId);
        updateSelectionUI();
      });

      if (calendarGrid) {
        calendarGrid.addEventListener('click', async (event) => {
          const button = event.target.closest('[data-date]');
          if (!button || button.disabled) return;

          if (dateSelect.value === button.dataset.date) return;

          nextInteractionToken();
          dateSelect.value = button.dataset.date;
          await invalidateHold();
          if (isSingleMode) {
            selectedSlots = [];
            updateSelectionUI();
          }
          const selectedMonthDate = parseDateValue(dateSelect.value);
          if (selectedMonthDate) {
            visibleMonth = {
              year: selectedMonthDate.getFullYear(),
              month: selectedMonthDate.getMonth()
            };
          }
          populateTimes();
          renderCalendar();
        });
      }

      if (calendarPrev) {
        calendarPrev.addEventListener('click', () => {
          const monthKeys = Array.from(new Set(availability.map((entry) => monthKeyForDate(entry.date)))).filter(Boolean);
          const currentKey = visibleMonth ? `${visibleMonth.year}-${visibleMonth.month}` : '';
          const currentIndex = monthKeys.indexOf(currentKey);
          if (currentIndex > 0) {
            const [year, month] = monthKeys[currentIndex - 1].split('-').map(Number);
            visibleMonth = { year, month };
            renderCalendar();
          }
        });
      }

      if (calendarNext) {
        calendarNext.addEventListener('click', () => {
          const monthKeys = Array.from(new Set(availability.map((entry) => monthKeyForDate(entry.date)))).filter(Boolean);
          const currentKey = visibleMonth ? `${visibleMonth.year}-${visibleMonth.month}` : '';
          const currentIndex = monthKeys.indexOf(currentKey);
          if (currentIndex > -1 && currentIndex < monthKeys.length - 1) {
            const [year, month] = monthKeys[currentIndex + 1].split('-').map(Number);
            visibleMonth = { year, month };
            renderCalendar();
          }
        });
      }

      holdButton.addEventListener('click', async () => {
        const token = nextInteractionToken();
        try {
          await invalidateHold();
          await createHold(token);
        } catch (error) {
          if (token !== interactionToken) return;
          console.error(error);
          setStatus(
            getBookingErrorMessage(
              error,
              'Unable to reserve the selected times right now. Please try again.'
            ),
            'error'
          );
          submitButton.disabled = true;
        }
      });

        variantSelect.addEventListener('change', async () => {
          nextInteractionToken();
          const previousVariantId = currentVariantId;
          await invalidateHold({ storageKey: previousVariantId });
          currentVariantId = variantSelect.value;
          dateSelect.value = '';
          resetBookingUiState();
          bookingConfig = { intakeFields: [] };
          renderIntakeFields();
          updateSelectionUI();
          await loadBookingConfig();
          await loadAvailability();
        await restorePersistedHold();
      });

      form.addEventListener('submit', (event) => {
        syncIntakeAnswersInput();
        if (!validateIntakeAnswers({ showErrors: true })) {
          event.preventDefault();
          setStatus('Complete the required class questions before continuing to checkout.', 'error');
          return;
        }

        if (!hold || !holdIdInput.value) {
          event.preventDefault();
          setStatus('Reserve your selected time before continuing to checkout.', 'error');
          return;
        }

        if (bookingReferenceInput) {
          bookingReferenceInput.value = `${holdIdInput.value || 'booking'}:${Date.now()}`;
        }

        clearStoredHoldState();
        clearHoldTimer();
        hold = null;
        activeHoldToken = 0;
      });

      (async () => {
        resetBookingUiState();
        await loadBookingConfig();
        await loadAvailability();
        updateSelectionUI();
        await restorePersistedHold();
        finishInitialAvailabilityLoadingState();
      })();
    };

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
          initGallery(document);
          initProductPage(document);
        });
      } else {
        initGallery(document);
        initProductPage(document);
      }

      window.addEventListener('pageshow', (event) => {
        if (event.persisted) {
          window.location.reload();
        }
      });

      document.addEventListener('shopify:section:load', (event) => {
        initGallery(event.target);
        initProductPage(event.target);
      });
  })();

  } catch(e) { console.error(e); }
})();
})();
